import axiosInstance from "../utils/axios";

export const appContentEnsure = () => axiosInstance.get("/app-content/admin/ensure");
export const getAppContents = () => axiosInstance.get("/app-content/admin/list");
export const getAppMarkets = () => axiosInstance.get("/app-content/admin/markets");
export const saveAppMarket = payload => axiosInstance.post("/app-content/admin/markets", payload);
export const getAppGenres = market => axiosInstance.get(`/app-content/admin/genres?market=${encodeURIComponent(market || "")}`);
export const saveAppGenre = payload => axiosInstance.post("/app-content/admin/genres", payload);
export const getLegacyBooks = () => axiosInstance.get("/app-content/admin/legacy-books");
export const createAppContent = payload => axiosInstance.post("/app-content/admin/create", payload);
export const updateAppContent = (id, payload) => axiosInstance.post(`/app-content/admin/update/${id}`, payload);
export const deleteAppContent = id => axiosInstance.delete(`/app-content/admin/delete/${id}`);


export const uploadAppCover = formData =>
  axiosInstance.post("/upload/image", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
